import { cn } from "@babackapp/ui/lib/utils";
import { Safari } from "@babackapp/ui/components/safari";
import type { ReactNode } from "react";

// Web editor uses landscape orientation
const WebEditorContentWidth = {
  desktop: 800, // Landscape width
  mobile: 375, // Mobile still portrait
  code: 1400,
} as const;

export interface WebMainContainerProps {
  children: ReactNode;
  viewport?: "desktop" | "mobile" | "code";
  backgroundColor?: string;
  isEditor?: boolean;
  editorClassName?: string;
  editorStyle?: React.CSSProperties;
}

export function WebMainContainer({
  children,
  viewport = "desktop",
  backgroundColor = "#f0f0f0",
  isEditor = false,
  editorClassName,
  editorStyle,
}: WebMainContainerProps) {
  const containerWidth = WebEditorContentWidth[viewport];
  const containerPadding = viewport === "mobile" ? "0 16px" : "0";
  const safariHeight =
    viewport === "mobile" ? 800 : Math.round(containerWidth * 0.75); // 16:10 aspect ratio

  if (isEditor) {
    return (
      <div
        className={cn(
          "group/editor w-full border flex-1 p-6 flex items-center justify-center flex-col rounded-xl",
          editorClassName,
        )}
        style={editorStyle}
      >
        <div
          className="mx-auto flex flex-col justify-center items-center"
          style={{
            maxWidth: containerWidth,
            width: containerWidth,
            padding: containerPadding,
          }}
        >
          <Safari
            url="track.baback.co/tracking/24ef32r3"
            width={containerWidth}
            height={safariHeight}
          >
            <div
              className="flex justify-center w-full min-h-full"
              style={{ backgroundColor }}
            >
              <div className="w-full max-w-[550px] py-8 px-4">{children}</div>
            </div>
          </Safari>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
